import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';


import { Redirect, withRouter, Link } from 'react-router-dom';
import store from "../state/space" 

import { Copyright } from '../components';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: 'red'
  }
}));



const OrgInvite = ({ match: { params }}) => {
  const classes = useStyles();
  const [firstName, setFirstName] = useState('Bob');
  const [lastName, setLastName] = useState('Frank');
  const [email, setEmail] = useState('eg.eg@eg.eg');
  const [orgName, setOrgName] = useState('Mindsett Dev');
  const [error, setError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  

  // prepopulate your details
  //


  const submit = () => {
    window.location.href = `/#/set-password/${params.id}`
  }

  const handleKeyPress = e => {
    //  check if both passwords exist
    if (firstName.length < 1 || lastName.length < 1 || email.length < 1 || orgName.length < 1) return setIsButtonDisabled(true);
    else setIsButtonDisabled(false);
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || submit();
    }
  };
  return (

    <Container component="main" maxWidth="xs">
      {store.isLoggedIn() ? <Redirect to="/" /> : null}
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography variant="h5">
            User Registration
        </Typography>
        <Typography variant="h7">
          Before you continue, please double check your details.
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="firstName"
            label="First Name"
            name="firstName"
            autoComplete="first-name"
            autoFocus
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            onKeyUp={(e) => handleKeyPress(e)}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="lastName"
            label="Last Name"
            id="lastName"
            autoComplete="last-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onKeyUp={(e) => handleKeyPress(e)}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="email"
            label="Email"
            id="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={(e) => handleKeyPress(e)}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="orgName"
            label="Organisation Name"
            id="orgName"
            autoComplete="org-name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            onKeyUp={(e) => handleKeyPress(e)}
            disabled={true}
          />

          <Typography varient="h7" className={classes.error}>
            {error}
          </Typography>

          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => submit()}
            disabled={isButtonDisabled}
          >
            Continue 
          </Button>

        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default withRouter(OrgInvite)